import { useState } from "react";
import MarkupGenerator from "../MarkupGenerator/MarkupGenerator";

export const Notification = ({ data }) => {
  const {description__value} = data;
  return <MarkupGenerator className="notification" string={description__value}/>;
};
